/*!
 * promise-proxy v0.10.20 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { curry, compose, map } from 'ramda';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var makeProxy = curry(function makeProxy(methods, promise) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  promise.$data = Object.assign({}, data, promise.$data);
  promise.$chain = (promise.$chain || []).concat([{
    promise: promise,
    methods: methods
  }]);
  return promise;
});
var PromiseProxy =
/*#__PURE__*/
function () {
  function PromiseProxy(proxy) {
    _classCallCheck(this, PromiseProxy);

    this.$proxy = proxy;
    this.$data = proxy.$data;
    this.$injectMethods();
  }

  _createClass(PromiseProxy, [{
    key: "$injectMethods",
    value: function $injectMethods() {
      var _this = this;

      this.$proxy.$chain.forEach(function (_ref) {
        var methods = _ref.methods;

        if (!methods) {
          return;
        }

        var _loop = function _loop(method) {
          if (!methods.hasOwnProperty(method)) {
            return "continue";
          }

          _this[method] = function () {
            return methods[method].apply(this, arguments);
          };
        };

        for (var method in methods) {
          var _ret = _loop(method);

          if (_ret === "continue") continue;
        }
      });
    }
  }, {
    key: "$apply",
    value: function $apply(name, args) {
      return this.$update(this.$proxy[name].apply(this.$proxy, args));
    }
  }, {
    key: "$update",
    value: function $update(promise) {
      promise.$data = this.$proxy.$data;
      promise.$chain = this.$proxy.$chain;
      return new this.constructor(promise);
    }
  }, {
    key: "then",
    value: function then() {
      return this.$apply('then', arguments);
    }
  }, {
    key: "catch",
    value: function _catch() {
      return this.$apply('catch', arguments);
    }
  }, {
    key: "finally",
    value: function _finally() {
      return this.$apply('finally', arguments);
    }
  }]);

  return PromiseProxy;
}();
var createProxyExecutor = curry(function (methods, proxy) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return makeProxy(methods, proxy.$proxy || proxy, data);
});
var initProxy = function initProxy(proxy) {
  return new PromiseProxy(proxy.$proxy || proxy);
};

var composeExecutorCreator = function composeExecutorCreator(obj) {
  return typeof obj === 'function' ? obj : createProxyExecutor(obj);
};

function composeProxies() {
  return compose(initProxy, compose.apply(this, map(composeExecutorCreator, arguments)));
}
var createProxy = composeProxies;

export { PromiseProxy, composeProxies, createProxy, createProxyExecutor, initProxy, makeProxy };
